import { isCJKCharacter } from './char';

export const breakTextByLimit = (text: string, lineLimit: number, lineCharLimit: number) => {
    if (!text) {
        return '';
    }

    const ellipsisChar = '…';
    const getCharWidth = (char: string) => (isCJKCharacter(char) ? 1 : 0.5);

    const isEnglishWord = (token: string) => {
        if (/\s/.test(token)) {
            return false;
        }
        for (const ch of token) {
            if (isCJKCharacter(ch)) {
                return false;
            }
        }
        return true;
    };

    const tokens: string[] = text.match(/(\S+|\s+)/g) || [];

    const lines = [''];
    const lineWidths = [0];
    const locked = [false];

    const appendEllipsis = () => {
        lines[lines.length - 1] = lines[lines.length - 1].trimEnd() + ellipsisChar;
        return lines.join('\n');
    };

    const newLine = () => {
        if (lines.length === lineLimit) {
            return false;
        }
        lines.push('');
        lineWidths.push(0);
        locked.push(false);
        return true;
    };

    for (const token of tokens) {
        if (lines[lines.length - 1].trim() === '') {
            lines[lines.length - 1] = '';
            lineWidths[lines.length - 1] = 0;
            locked[lines.length - 1] = false;
        }

        if (lines[lines.length - 1] === '' && /^\s+$/.test(token)) {
            continue;
        }

        if (token.includes('\n')) {
            const parts = token.split('\n');
            parts.forEach((part, index): any => {
                if (lines[lines.length - 1] === '' && part && /^\s+$/.test(part)) {
                    part = '';
                }
                if (part) {
                    if (isEnglishWord(part)) {
                        const tokenWidth = part.split('').reduce((sum, ch) => sum + getCharWidth(ch), 0);
                        if (
                            locked[lines.length - 1] ||
                            (lineWidths[lines.length - 1] > 0 &&
                                lineWidths[lines.length - 1] + tokenWidth > lineCharLimit)
                        ) {
                            if (!newLine()) {
                                return appendEllipsis();
                            }
                        }
                        lines[lines.length - 1] += part;
                        lineWidths[lines.length - 1] += tokenWidth;
                        if (lineWidths[lines.length - 1] === tokenWidth && tokenWidth > lineCharLimit) {
                            locked[lines.length - 1] = true;
                        }
                    } else {
                        for (const ch of part) {
                            const w = getCharWidth(ch);
                            if (locked[lines.length - 1] || lineWidths[lines.length - 1] + w > lineCharLimit) {
                                if (!newLine()) {
                                    return appendEllipsis();
                                }
                            }
                            lines[lines.length - 1] += ch;
                            lineWidths[lines.length - 1] += w;
                        }
                    }
                }
                if (index < parts.length - 1) {
                    if (!newLine()) {
                        return appendEllipsis();
                    }
                }
            });
            continue;
        }

        if (isEnglishWord(token)) {
            const tokenWidth = token.split('').reduce((sum, ch) => sum + getCharWidth(ch), 0);
            if (
                locked[lines.length - 1] ||
                (lineWidths[lines.length - 1] > 0 && lineWidths[lines.length - 1] + tokenWidth > lineCharLimit)
            ) {
                if (!newLine()) {
                    return appendEllipsis();
                }
            }
            lines[lines.length - 1] += token;
            lineWidths[lines.length - 1] += tokenWidth;
            if (lineWidths[lines.length - 1] === tokenWidth && tokenWidth > lineCharLimit) {
                locked[lines.length - 1] = true;
            }
        } else {
            for (const ch of token) {
                const w = getCharWidth(ch);
                if (locked[lines.length - 1] || lineWidths[lines.length - 1] + w > lineCharLimit) {
                    if (!newLine()) {
                        return appendEllipsis();
                    }
                }
                lines[lines.length - 1] += ch;
                lineWidths[lines.length - 1] += w;
            }
        }
    }

    if (locked[lines.length - 1] && !lines[lines.length - 1].endsWith(ellipsisChar)) {
        lines[lines.length - 1] = lines[lines.length - 1].trimEnd() + ellipsisChar;
    }

    return lines.join('\n');
};
